import appModule from '@/app-module';

export default {
  beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.auth) {
      next();
      return;
    }

    const store = appModule.storeAsync();

    store.dispatch('auth/waitUntilInit').then(() => {
      if (store.getters['auth/authenticated']) {
        if (
          to.name !== 'emailUnverified' &&
          !store.getters['auth/emailVerified']
        ) {
          next({ name: 'emailUnverified' });
          return;
        }

        if (
          to.name !== 'emptyPermissions' &&
          store.getters['auth/emailVerified'] &&
          !store.getters['auth/hasRole']()
        ) {
          next({ name: 'emptyPermissions' });
          return;
        }

        next();
      } else {
        next({ name: 'login' });
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/auth/guards/auth-guard-mixin.js